export const getLocationType = (location = { type: '' }) => location?.type || ''
